export default __webpack_public_path__ + "static/media/header-doc.c2a3e9b0.jpg";